import { useTheme } from "@mui/material";
import type { FC } from "react";
import { BADGE, SURFACE } from "@/theme/tokens";
import MetaChip from "@/ui/Badges/MetaChip";
import type { OutreachRowBadge as OutreachRowBadgeView } from "./outreachGroupTypes";

/** A status pill: soft (tint and edge in its tone) or solid (filled, for an outcome — accepted, approved). */
export const OutreachRowBadge: FC<{ badge: OutreachRowBadgeView; dataTestId: string }> = ({ badge, dataTestId }) => {
	const theme = useTheme();
	const solid = badge.solid && badge.tone !== "neutral" ? { ink: SURFACE, bg: theme.palette[badge.tone].main } : undefined;
	return (
		<MetaChip size="small" tone={badge.tone} customTone={solid} label={badge.label} dataTestId={dataTestId} sx={{ borderRadius: BADGE.PILL_RADIUS_FULL }} />
	);
};
